var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateCcw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#78849e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.165)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(-0.165)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.835 10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.456,38.132a3.591,3.591,0,0,0-3.553,3.1l.263-.263a.654.654,0,0,1,1.118.463.646.646,0,0,1-.192.463l-1.413,1.414a.655.655,0,0,1-.927,0L20.339,41.9a.654.654,0,0,1,0-.926.67.67,0,0,1,.926,0l.314.314a4.9,4.9,0,0,1,4.877-4.464.655.655,0,1,1,0,1.31Z",
    transform: "translate(-19.581 -35.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.927,45.021H17.32V36.628a.655.655,0,0,1,.655-.655h9.047a.656.656,0,0,1,.655.655V50.2a.656.656,0,0,1-.655.655H23.153v3.868a.655.655,0,0,1-.655.655H8.927a.656.656,0,0,1-.655-.655V45.676A.656.656,0,0,1,8.927,45.021Zm.655,1.31v7.737H21.843V50.855H17.975a.655.655,0,0,1-.655-.655V46.331Zm9.048-9.048V49.545h7.737V37.283Z",
    transform: "translate(-8.272 -35.973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCcw);
export default __webpack_public_path__ + "static/media/rotate-ccw.776a412a515b6623758499fb961ab197.svg";
export { ForwardRef as ReactComponent };